import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=3837950a&scoped=true"
import script from "./reset-password.ts?vue&type=script&lang=js&external"
export * from "./reset-password.ts?vue&type=script&lang=js&external"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=3837950a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837950a",
  null
  
)

export default component.exports